const ENV = 0
let config = {
    env: ENV,
    ws_login:'',
    ws_jf: '',
    al_url: ''
}
switch (ENV) {
    case 0: // 生产环境
        config.ws_jf = 'ws://baoquan.court.gov.cn/wsbq/commonapi/api/web/socket'
        config.ws_login = 'ws://baoquan.court.gov.cn/wsbq/account/api/web/socket/'
        config.al_url = 'https://account.court.gov.cn'
        break;
    case 1: // 18测试环境
        config.ws_jf = 'ws://172.16.70.24/wsbq/commonapi/api/web/socket/'
        config.ws_login = 'ws://172.16.70.24/wsbq/account/api/web/socket/'
        config.al_url = 'https://akan.sandbox.gdapi.net'
        break;
    case 2: // 5001测试环境
        config.ws_jf = 'ws://172.16.70.24:5001/wsbq/commonapi/api/web/socket/'
        config.ws_login = 'ws://172.16.70.24:5001/wsbq/account/api/web/socket/'
        config.al_url = 'https://akan.sandbox.gdapi.net'
        break;
}

export default config
